import { useMemo } from 'react'
import styled from '@emotion/styled'
import DOMPurify from 'dompurify'

// I just copied these styles from L1Markdown...
// they probably need to be adjusted to look good
const StyledHtml = styled.div(({theme}) => ({
	p: {
		margin: theme.spacing(0, 0, 1),
	},
	ul: {
		margin: theme.spacing(0, 0, 1),
	},
	'*:last-child': {
		margin: 0,
	},
}))

interface L1PurifiedHtmlProps {
	content?: string
}

const L1PurifiedHtml = ({content}: L1PurifiedHtmlProps) => {
	const purified = useMemo(() => {
		return {
			__html: content ? DOMPurify.sanitize(content) : '',
		}
	}, [content])
	return <StyledHtml dangerouslySetInnerHTML={purified} />
}

export default L1PurifiedHtml
